/**
 * Formats an unread notification count for compact UI labels.
 * @param {number} count The unread notification count.
 * @returns {string} The count, capped at three digits with a plus suffix.
 */
export function formatNotificationCount(count: number): string {
  return count > 999 ? '999+' : `${count}`
}
